// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dz-a";
export var fulfillmentFormRail = "_dz-9";
export var headerTitleRow = "_dz-c";
export var orderDetailsWrapper = "_dz-7";
export var orderLinkTrigger = "_dz-2";
export var paymentInformationGrid = "_dz-h";
export var paymentSummaryColumn = "_dz-i";
export var shipmentContainer = "_dz-b";
export var shipmentDetailsMainPane = "_dz-8";
export var shipmentNavigationCard = "_dz-5";
export var shipmentNavigationRail = "_dz-3";
export var shipmentNavigationRailHeader = "_dz-4";
export var shipmentSummaryFact = "_dz-e";
export var shipmentSummaryGrid = "_dz-d";
export var shipmentSummaryMetadataRow = "_dz-f";
export var shipmentSummaryTags = "_dz-g";
export var shipmentWorkspace = "_dz-0";
export var shipmentWorkspaceContent = "_dz-6";
export var shipmentWorkspaceHeader = "_dz-1";